import { CoreModule } from "@modules/core/core.module";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { ToggleInputModule } from "@modules/shared/bp-toggle/toggle-input.module";
import { TermsAndConditionsUpdatesComponent } from "./terms-and-conditions-updates.component";

@NgModule({
	declarations: [TermsAndConditionsUpdatesComponent],
	imports: [CoreModule, ReactiveFormsModule, ToggleInputModule],
	exports: [TermsAndConditionsUpdatesComponent]
})
export class TermsAndConditionsUpdatesModule {}
